import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { bookingStatusFilterOptions } from '@new/__global/constants/filter'

import { FiltersSharedProps } from './Filters.types'

interface BookingStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  shouldUpdateOnInitialValueChange?: boolean
  title: string
}

export const BookingStatusFilter: FC<BookingStatusFilterProps> = props => (
  <CheckboxBasedFilter options={bookingStatusFilterOptions} {...props} />
)
